module.exports = __webpack_public_path__ + "static/media/ion_name.cb9be45d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ion_name.jpg
// module id = 1768
// module chunks = 1